import React, { useState } from "react";
import MinusButton from "../../../../components/MinusButton";
import { toast } from "../../../../components/toastNotification";
import {
  Control,
  Controller,
  FieldValues,
  useFormContext,
} from "react-hook-form";
import { ICarrierFiles } from "../types";

interface CarrierAttachmentsProps {
  setIsFileDeletes;
}

const CarrierAttachments = ({ setIsFileDeletes }: CarrierAttachmentsProps) => {
  const useFormMethods = useFormContext();
  const { control, watch, setValue } = useFormMethods;

  const removeFile = (file: ICarrierFiles) => {
    if (
      watch("carrierFiles")?.filter(
        (newFile: ICarrierFiles) => newFile.sourceFile === file.sourceFile
      )
    ) {
      setValue(
        "carrierFiles",
        watch("carrierFiles")?.filter(
          (newFile: ICarrierFiles) => newFile.sourceFile !== file.sourceFile
        )
      );
      setIsFileDeletes(true);
    }
  };
  return (
    <>
      <div className="text-xs">
        <div className="bg-LightWhite flex flex-col overflow-y-auto text-xs divide-y">
          {watch("carrierFiles") &&
            watch("carrierFiles")?.map((file: any, i) => {
              return (
                <div key={i} className="flex justify-between px-2 py-1">
                  <div className="font-semibold text-left text-primary pr-2">
                    {file?.sourceFile}
                  </div>
                  <div className="flex items-center">
                    <MinusButton
                      onClick={() => {
                        removeFile(file);
                      }}
                    />
                  </div>
                </div>
              );
            })}
        </div>
        <div className="flex justify-center pt-2">
          <label
            className="w-1/2 text-center bg-primary text-white
                   py-1 px-1 border font-medium rounded-full cursor-pointer hover:bg-white hover:text-primary hover:border-primary"
          >
            <Controller
              name="attachments"
              control={control}
              defaultValue={[]}
              render={({ field }) => {
                return (
                  <input
                    type="file"
                    className="hidden"
                    multiple
                    {...field}
                    value={field.value.name}
                    onChange={(e) => {
                      if (e.target.files) {
                        const newFiles = Array.from(e.target.files);
                        field.onChange([...newFiles]);
                        const existingFiles = watch("carrierFiles") && [
                          ...watch("carrierFiles"),
                        ];
                        newFiles.forEach((file) => {
                          if (
                            existingFiles?.findIndex(
                              (obj: any) => obj.sourceFile === file.name
                            ) === -1
                          ) {
                            existingFiles.push({ sourceFile: file.name });
                          } else {
                            toast.fire(
                              "Attachment failed",
                              "File already exist",
                              "error"
                            );
                          }
                        });
                        existingFiles &&
                          setValue("carrierFiles", existingFiles);
                      }
                    }}
                  />
                );
              }}
            />
            Choose File
          </label>
        </div>
      </div>
    </>
  );
};

export default CarrierAttachments;
